export default {
      id: "presence-available-usage",
      viewBox: "0 0 10 10",
      url: "/dist/svg/" + "sprite.svg#presence-available-usage",
      toString: function () {
        return this.url;
      }
    }